/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineQuantityByGuestsDto } from './traveline-quantity-by-guests-dto';
import {
    TravelineQuantityByGuestsDtoFromJSON,
    TravelineQuantityByGuestsDtoFromJSONTyped,
    TravelineQuantityByGuestsDtoToJSON,
    TravelineQuantityByGuestsDtoToJSONTyped,
} from './traveline-quantity-by-guests-dto';

/**
 * Extra service for accommodation
 * @export
 * @interface TravelineRoomStayServiceRqDto
 */
export interface TravelineRoomStayServiceRqDto {
    /**
     * Service ID
     * @type {string}
     * @memberof TravelineRoomStayServiceRqDto
     */
    id: string;
    /**
     * Number of extra services<br />
     * This parameter is used for "PerStay", "PerPerson", and "PerUse" charge types.
     * @type {number}
     * @memberof TravelineRoomStayServiceRqDto
     */
    quantity?: number | null;
    /**
     * 
     * @type {TravelineQuantityByGuestsDto}
     * @memberof TravelineRoomStayServiceRqDto
     */
    quantityByGuests?: TravelineQuantityByGuestsDto;
}

/**
 * Check if a given object implements the TravelineRoomStayServiceRqDto interface.
 */
export function instanceOfTravelineRoomStayServiceRqDto(value: object): value is TravelineRoomStayServiceRqDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function TravelineRoomStayServiceRqDtoFromJSON(json: any): TravelineRoomStayServiceRqDto {
    return TravelineRoomStayServiceRqDtoFromJSONTyped(json, false);
}

export function TravelineRoomStayServiceRqDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRoomStayServiceRqDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'quantityByGuests': json['quantityByGuests'] == null ? undefined : TravelineQuantityByGuestsDtoFromJSON(json['quantityByGuests']),
    };
}

  export function TravelineRoomStayServiceRqDtoToJSON(json: any): TravelineRoomStayServiceRqDto {
      return TravelineRoomStayServiceRqDtoToJSONTyped(json, false);
  }

  export function TravelineRoomStayServiceRqDtoToJSONTyped(value?: TravelineRoomStayServiceRqDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'quantity': value['quantity'],
        'quantityByGuests': TravelineQuantityByGuestsDtoToJSON(value['quantityByGuests']),
    };
}

